// Kleurvolgorde voor filterchips. Gesorteerd op aantal ziet een kleurenrij
// er willekeurig uit en moet het oog lineair scannen; spectrale volgorde
// (neutrals → regenboog → trans → pearl/metallic) laat je ruimtelijk zoeken:
// "rood zit vooraan, blauw verderop". Zelfde conventie als BrickLink's
// kleurgids en e-commerce-kleurfilters.

function hexToHsl(hex) {
  const clean = String(hex || '').replace(/^#/, '');
  if (!/^[0-9a-fA-F]{6}$/.test(clean)) return null;
  const r = parseInt(clean.slice(0, 2), 16) / 255;
  const g = parseInt(clean.slice(2, 4), 16) / 255;
  const b = parseInt(clean.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  if (max === min) return { h: 0, s: 0, l };
  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h;
  if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) * 60;
  else if (max === g) h = ((b - r) / d + 2) * 60;
  else h = ((r - g) / d + 4) * 60;
  return { h, s, l };
}

// Finish-groepen: effen kleuren eerst, dan transparant, dan speciaal
function finishGroup(name) {
  const n = String(name || '').toLowerCase();
  if (n.startsWith('trans')) return 2;
  if (/^(pearl|metallic|chrome|satin|glitter|speckle|milky|glow|copper|flat silver|flat dark gold)/.test(n)) return 3;
  return 1;
}

// Sorteersleutel: [finish, neutraal?, tint-bucket, donkerte]
export function colorSortKey(name, hex) {
  const hsl = hexToHsl(hex);
  const finish = finishGroup(name);
  if (!hsl) return [finish, 1, 99, 0];
  // Bijna-zwart heeft in HSL vaak hoge verzadiging (Black #05131D → s≈0.7)
  // maar oogt neutraal - heel donkere kleuren horen bij de neutrals
  const neutral = hsl.s < 0.13 || hsl.l < 0.1;
  if (neutral) return [finish, 0, 0, 1 - hsl.l];
  // 12 tint-buckets, +15° zodat de hele rood-familie (h ~345-15) bucket 0 is
  const bucket = Math.floor((((hsl.h + 15) % 360) / 30));
  return [finish, 1, bucket, 1 - hsl.l];
}

export function sortColorOptions(colors) {
  return [...colors].sort((a, b) => {
    const ka = colorSortKey(a.name, a.hex);
    const kb = colorSortKey(b.name, b.hex);
    for (let i = 0; i < ka.length; i++) {
      if (ka[i] !== kb[i]) return ka[i] - kb[i];
    }
    return String(a.name).localeCompare(String(b.name));
  });
}

// Gangbare LEGO-kleuren voor de globale Find My Bag-filter (Rebrickable-
// namen + hexwaarden). De backend herkent deze namen in de zoekquery.
export const COMMON_FILTER_COLORS = sortColorOptions([
  { name: 'White', hex: 'FFFFFF' },
  { name: 'Light Bluish Gray', hex: 'A0A5A9' },
  { name: 'Dark Bluish Gray', hex: '6C6E68' },
  { name: 'Black', hex: '05131D' },
  { name: 'Tan', hex: 'E4CD9E' },
  { name: 'Dark Tan', hex: '958A73' },
  { name: 'Reddish Brown', hex: '582A12' },
  { name: 'Red', hex: 'C91A09' },
  { name: 'Dark Red', hex: '720E0F' },
  { name: 'Orange', hex: 'FE8A18' },
  { name: 'Yellow', hex: 'F2CD37' },
  { name: 'Lime', hex: 'BBE90B' },
  { name: 'Green', hex: '237841' },
  { name: 'Dark Green', hex: '184632' },
  { name: 'Medium Azure', hex: '36AEBF' },
  { name: 'Blue', hex: '0055BF' },
  { name: 'Dark Blue', hex: '0A3463' },
  { name: 'Medium Lavender', hex: 'AC78BA' },
  { name: 'Dark Purple', hex: '3F3691' },
  { name: 'Bright Pink', hex: 'E4ADC8' },
]);
